import { Integration } from "types";

const checkIfIntegrationActionRequired = (integrations: Integration[]) => {
  return integrations.some((integration) => integration.disconnected);
};

export default checkIfIntegrationActionRequired;
